const Dark = {
  main_bg_color: "#2A2D2E",
  txt_color: '#ffffff',
  input_bg_color: "#343a40",
  input_disabled: "#24282b",
  input_placeholder: "rgba(255,255,255,.5)",
  bg_row_fixed: "#454647",
  iconInput: "invert(100%) sepia(100%) saturate(0%) hue-rotate(33deg) brightness(103%) contrast(103%)",
  card_dash: "rgb(44, 47, 56)",
  table_change_color_hover: '#464849'
};

const Light = {
  main_bg_color: "#EFEFEF",
  txt_color: '#1c1c1c',
  input_bg_color: "#fff",
  input_disabled: "#E9ECEF",
  input_placeholder: "gray",
  bg_row_fixed: "#c3c6c9",
  iconInput: "invert(0%) sepia(0%) saturate(7500%) hue-rotate(272deg) brightness(108%) contrast(108%)",
  card_dash: "#ededed",
  table_change_color_hover: '#bbbfc4'
}

const switchTheme = c => {
  let theme = {};
  let chosen = c;
  if (!c) {
    chosen = "light";
  }

  if (chosen === "dark") {
    theme = Dark;
  } else if (chosen === "light") {
    theme = Light;
  }
  localStorage.setItem("theme", chosen);
  applyStyle(theme);
};

const applyStyle = style => {
  let setStyle = document.documentElement.style;

  //Background
  setStyle.setProperty("--main-bg-color", style.main_bg_color);
  //Principal text color
  setStyle.setProperty("--txt-color", style.txt_color);
   //Input Background
   setStyle.setProperty("--input-bg-color", style.input_bg_color);
   //input disabled
   setStyle.setProperty("--input-disabled", style.input_disabled);
   //BG Hover of fixed row - rankings
   setStyle.setProperty("--bg-row-fixed", style.bg_row_fixed);
   //Icon of default Inputs
   setStyle.setProperty("--icon-input", style.iconInput);
   //Card Dash
   setStyle.setProperty("--card-dash", style.card_dash);
   //Hover table change color
   setStyle.setProperty("--table-change-color-hover", style.table_change_color_hover);
    //input placeholder
    setStyle.setProperty("--input-placeholder", style.input_placeholder);
};

export default switchTheme;
